import * as React from "react";
import { forwardRef, memo } from "react";
const SvgAttachFile = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M460-80q-92 0-156-64t-64-156v-420q0-66 47-113t113-47 113 47 47 113v380q0 42-29 71t-71 29-71-29-29-71v-350q0-13 8.5-21.5T390-720t21.5 8.5T420-690v350q0 17 11.5 28.5T460-300t28.5-11.5T500-340v-380q0-42-29-71t-71-29-71 29-29 71v420q0 66 47 113t113 47 113-47 47-113v-390q0-13 8.5-21.5T650-720t21.5 8.5T680-690v390q0 92-64 156T460-80" })));
const ForwardRef = forwardRef(SvgAttachFile);
const Memo = memo(ForwardRef);
export default Memo;
